module.exports = __webpack_public_path__ + "static/starter-card-f893fbedf7d72de06ca396920fbfc411.png";